import React, { Fragment, useState, useRef } from 'react';
import { Controller, useForm, ErrorMessage } from 'react-hook-form';
import { Grid, Button } from '@material-ui/core';
import { useStyle } from './style';
import { TextField } from '@material-ui/core';
import errormesages from './errormessages';
import axios from 'axios';
import { Modal, ModalBody,Label } from 'reactstrap';

export default function EirRemindMe(props) {
    const { control, errors, handleSubmit } = useForm({
        reValidateMode: 'onChange',
    });
    const { validation } = errormesages;
    const bankAccNumberInputRef = useRef();
    const sortCodeInputRef = useRef();
    const displayModel = props.displayModel;
    const classes = useStyle();
    const toggleModel = props.toggleModel;
    const [errorMessage, setErrorMessage] = useState(false);
    const [successMessage, setSuccessMessage] = useState(false);
    const [IBAN, setIBAN] = useState();
    const [BIC, setBIC] = useState();
    const setibanValue = props.setibanValue;
    const setbicValue = props.setbicValue;

    const remindMe = (data) => {
        axios.get(`https://www.eir.ie/store/api/checkout/sepa/transform/${data.bankAccNumber}/${data.sortCode}`)
            .then(res => {
                //console.log(res);
                if (res.data.success) {
                    setSuccessMessage(true);
                    setIBAN(res.data.iban);
                    setBIC(res.data.bic);
                }
                else {
                    setErrorMessage(true);
                }
            });
    }
    const tryAgain = () => {
        setErrorMessage(false);
    }
    const onClick = () => {
        setibanValue(IBAN);     // passing iban and bic to parent component
        setbicValue(BIC);
        toggleModel();
    }

    return (

        <Fragment>
            <Modal className={classes.modalContainer} centered={true} isOpen={displayModel} toggle={toggleModel} >
                <ModalBody className={classes.modalContent}>
                    <Button className={classes.closeButton} onClick={toggleModel}></Button>
                    <h2 className={classes.popupHeading} >IBAN and BIC reminder</h2>
                    {!errorMessage && !successMessage &&
                        <form>
                            <Grid container className={classes.remindContainer + " remindContainer"} sm={12} xs={12}>
                                <Grid item sm={12} xs={12} className={classes.gridItemSpace}>
                                    <Label className={classes.popupLabel}>Bank account number <span style={{ color: 'red', textAlign: 'center' }} >*</span></Label>
                                    <Controller
                                        as={<TextField inputRef={bankAccNumberInputRef} color="secondary" />}
                                        control={control}
                                        fullWidth
                                        id="bankAccNumber"
                                        name="bankAccNumber"
                                        variant="outlined"
                                        size="small"
                                        required
                                        className={classes.popupInput + " popupInput"}
                                        error={Boolean(errors.bankAccNumber)}
                                        rules={{
                                            required: { value: true, message: validation.bankAccNumberRequired },
                                            pattern: { value: /^[0-9]{8}$/, message: validation.bankAccNumberPattern },
                                            minLength: { value: 8, message: validation.bankAccNumberMinLength },
                                            maxLength: { value: 8, message: validation.bankAccNumberMaxLength },
                                        }}
                                    />
                                    <ErrorMessage errors={errors} name="bankAccNumber">
                                        {({ message }) => <p className={classes.errorMessagePayment}>{message}</p>}
                                    </ErrorMessage>
                                </Grid>
                                <Grid item sm={12} xs={12} className={classes.gridItemSpace}>
                                    <Label className={classes.popupLabel}>Sort code <span style={{ color: 'red', textAlign: 'center' }} >*</span></Label>
                                    <Controller
                                        as={<TextField inputRef={sortCodeInputRef} color="secondary" />}
                                        control={control}
                                        fullWidth
                                        id="sortCode"
                                        name="sortCode"
                                        variant="outlined"
                                        size="small"
                                        required
                                        className={classes.popupInput + " popupInput"}
                                        error={Boolean(errors.sortCode)}
                                        rules={{
                                            required: { value: true, message: validation.sortCodeRequired },
                                            pattern: { value: /^[0-9]{6}$/, message: validation.sortCodePattern },
                                            minLength: { value: 6, message: validation.sortCodeMinLength },
                                            maxLength: { value: 6, message: validation.sortCodeMaxLength },
                                        }}
                                    />
                                    <ErrorMessage errors={errors} name="sortCode">
                                        {({ message }) => <p className={classes.errorMessagePayment}>{message}</p>}
                                    </ErrorMessage>
                                </Grid>
                                <Grid item sm={12} xs={12} >
                                    <Button className={classes.remindMeBtn} onClick={handleSubmit(remindMe)} > Remind me</Button>
                                </Grid>
                            </Grid>
                        </form>
                    }
                    {errorMessage &&
                        <Grid container className={classes.remindContainer + " remindContainer"} sm={12} xs={12}>
                            <Grid item sm={12} xs={12} className={classes.gridItemSpace}>
                                <p className={classes.remindMeErrorText}>There is a problem with the account number and sort code entered.</p>
                                <p className={classes.remindMeErrorText}>Please check the details and try again.</p>
                            </Grid>
                            <Grid item sm={12} xs={12} >
                                <Button className={classes.remindMeErrorBtn} onClick={tryAgain} > Try again</Button>
                            </Grid>
                        </Grid>
                    }
                    {successMessage &&
                        <Grid container className={classes.remindContainer + " remindContainer"} sm={12} xs={12}>
                            <Grid item sm={12} xs={12} className={classes.gridItemSpace}>
                                <p className={classes.remindMeSuccessText}>IBAN: <span className={classes.responseDetails}>{IBAN} </span></p>
                                <p className={classes.remindMeSuccessText}>BIC: <span className={classes.responseDetails}>{BIC} </span></p>
                            </Grid>
                            <Grid item sm={12} xs={12} >
                                <Button className={classes.remindMeSuccessBtn} onClick={onClick}> Yes, these are my IBAN and BIC</Button>
                            </Grid>
                        </Grid>
                    }
                </ModalBody>
            </Modal>
        </Fragment>
    );
}